/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
/* eslint-disable lines-around-comment */
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ExcalidrawApp } from '@jitsi/excalidraw';
import { getLocalParticipant } from 'store/modules/base/participants/functions';
import { getVerticalViewMaxWidth } from 'store/modules/filmstrip/functions';
import { getToolboxHeight } from 'store/modules/toolbox/functions';
import { WHITEBOARD_UI_OPTIONS } from 'store/modules/whiteboard/constants';
import {
  getCollabDetails,
  getCollabServerUrl,
  isWhiteboardOpen
} from 'store/modules/whiteboard/functions';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import Filmstrip from 'util/UI/videolayout/Filmstrip';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { IconButton } from '@mui/material';
import { CloseIcon } from 'assets/images';
import { setWhiteboardOpen } from 'store/modules/whiteboard/actions';
import { sendMessage } from 'store/modules/chat/actions';

/**
 * Space taken by meeting elements like the subject and the watermark.
 */
const HEIGHT_OFFSET = 80;

/**
 * The Whiteboard component.
 *
 * @returns {JSX.Element} - The React component.
 */
// eslint-disable-next-line no-unused-vars
const Whiteboard = ({ visible }) => {
  const excalidrawRef = useRef(null);
  const collabAPIRef = useRef(null);
  const excalidrawAPIRef = useRef(null);
  // eslint-disable-next-line no-unused-vars
  const isOpen = useSelector(isWhiteboardOpen);
  const dispatch = useDispatch();
  const { clientHeight, clientWidth } = useSelector(
    (state) => state['features/base/responsive-ui']
  );
  const { visible: filmstripVisible, isResizing } = useSelector(
    (state) => state['features/filmstrip']
  );
  const filmstripWidth = useSelector(getVerticalViewMaxWidth);
  const collabDetails = useSelector(getCollabDetails);
  const collabServerUrl = useSelector(getCollabServerUrl);
  const localParticipant = useSelector(getLocalParticipant);
  const { defaultRemoteDisplayName } = useSelector(
    (state) => state['features/base/config']
  );
  const localParticipantName =
    localParticipant?.name || defaultRemoteDisplayName || 'Fellow Jitster';

  useEffect(() => {
    if (!collabAPIRef.current) {
      return;
    }

    collabAPIRef.current.setUsername(localParticipantName);
  }, [localParticipantName]);

  useEffect(() => {
    setTimeout(() => {
      let ele = document.querySelector('.Island');
      if (ele) ele.remove();
    }, 1000);
  }, [isOpen]);
  /**
   * Computes the width and the height of the component.
   *
   * @returns {IDimensions} - The dimensions of the component.
   */
  const getDimensions = () => {
    let width;
    let height;

    if (interfaceConfig.VERTICAL_FILMSTRIP) {
      if (filmstripVisible) {
        width = clientWidth - filmstripWidth;
      } else {
        width = clientWidth;
      }
      height = clientHeight - getToolboxHeight();
    } else {
      if (filmstripVisible) {
        height = clientHeight - Filmstrip.getFilmstripHeight();
      } else {
        height = clientHeight;
      }
      // eslint-disable-next-line no-unused-vars
      width = clientWidth;
    }

    return {
      width: `85%`,
      height: `${height - HEIGHT_OFFSET}px`
    };
  };

  const getExcalidrawAPI = useCallback((excalidrawAPI) => {
    if (excalidrawAPIRef.current) {
      return;
    }
    excalidrawAPIRef.current = excalidrawAPI;
  }, []);

  const getCollabAPI = useCallback(
    (collabAPI) => {
      if (collabAPIRef.current) {
        return;
      }
      collabAPIRef.current = collabAPI;
      collabAPIRef.current.setUsername(localParticipantName);
    },
    [localParticipantName]
  );

  const closeWhiteboard = () => {
    dispatch(setWhiteboardOpen(false));
    const message = {
      EventType: 22,
      Message: 'Whiteboard',
      FromParticipantID: localParticipant.id
    };

    dispatch(sendMessage(JSON.stringify(message)));
  };

  const app = useMemo(() => {
    return (
      <div className="excalidraw-wrapper">
        <ExcalidrawApp
          collabDetails={collabDetails}
          collabServerUrl={collabServerUrl}
          excalidraw={{
            isCollaborating: true,
            ref: excalidrawRef,
            theme: 'light',
            UIOptions: WHITEBOARD_UI_OPTIONS
          }}
          getCollabAPI={getCollabAPI}
          getExcalidrawAPI={getExcalidrawAPI}
        />
        <IconButton
          className="App-toolbar"
          onClick={closeWhiteboard}
          sx={{
            position: 'absolute',
            right: 10,
            top: 10,
            zIndex: 10,
            borderRadius: '5px',
            padding: '10px',
            boxShadow:
              '0 0 0 1px rgba(0, 0, 0, 0.01), 1px 1px 5px rgba(0, 0, 0, 0.15)'
          }}>
          <CloseIcon color="black" />
        </IconButton>
      </div>
    );
  }, [collabDetails, collabServerUrl]);
  return (
    <Box
      className={clsx(isResizing && 'disable-pointer', 'whiteboard-container')}
      sx={{
        display: `${visible && isOpen ? 'block' : 'none'}`,
        position: 'fixed',
        zIndex: 10,
        width: '100%',
        height: '100%',
        '@media (min-width: 800px)': {
          ...getDimensions(),
          marginLeft: `${HEIGHT_OFFSET}px`
        }
      }}>
      {app}
    </Box>
  );
};

export default React.memo(withBoundary(Whiteboard));
